import { getUserHasSelectedPlace } from './HomeAutocomplete';

declare const BaseUrlWeb: string;
declare const bootbox: { alert(msg: string): void };

interface AjaxOptions {
    type: string;
    url: string;
    data?: Record<string, unknown>;
}

interface SchedaResponse {
    IsSuccess: boolean;
    urlScheda: string;
}

/**
 * Funzione per gestire i retry delle chiamate AJAX.
 */
async function retryAjax<T>(options: AjaxOptions, tryCount = 0, retryLimit = 3): Promise<T> {
    try {
        const response = await $.ajax(options);
        return response as T;
    } catch (error: unknown) {
        const jqXHR = error as JQuery.jqXHR;
        if ((jqXHR.statusText === 'timeout' || jqXHR.status === 400) && tryCount < retryLimit) {
            console.info(`Retry attempt ${tryCount + 1} of ${retryLimit}`);
            return retryAjax<T>(options, tryCount + 1, retryLimit);
        } else {
            console.error('Errore nella chiamata AJAX:', error);
            throw error;
        }
    }
}

export { retryAjax };

/**
 * Carica la scheda dettagliata in base al codice fornito.
 */
async function loadSchedaDettagliataByCodice(codice: string): Promise<void> {
    const url = BaseUrlWeb + 'Search/GetSchedaByCodice';
    const options: AjaxOptions = {
        type: 'GET',
        url: url,
        data: { lottoId: codice }
    };

    try {
        const response = await retryAjax<SchedaResponse>(options);
        if (response.IsSuccess) {
            window.location.href = response.urlScheda;
        } else {
            bootbox.alert('Nessuna scheda trovata per il codice inserito. Per favore, verifica il codice e riprova.');
        }
    } catch (error) {
        console.error('Errore nel recupero della uri della scheda dettagliata:', error);
        bootbox.alert('Si è verificato un errore durante il recupero della scheda. Per favore, riprova più tardi.');
    } finally {
        $('#loading2').hide();
    }
}

/**
 * Imposta le categorie e le sotto-categorie selezionate nel form e le salva nel sessionStorage.
 */
function setCategoryFiltersAndSaveToSession(formId: string): void {
    const selectedCategory = $(`#${formId} input[type="radio"]:checked`).val() as string | undefined;
    if (selectedCategory) {
        $(`#${formId} input[name=ListCategoriaId]`).val(selectedCategory);
    }

    const selectedSubCategories: string[] = [];
    $(`#${formId} input[type="checkbox"]:checked`).each(function () {
        selectedSubCategories.push($(this).val() as string);
    });

    if (selectedSubCategories.length > 0) {
        $(`#${formId} input[name='ListSubCategoriaId']`).remove();
        selectedSubCategories.forEach(value => {
            $('<input>').attr({
                type: 'hidden',
                name: 'ListSubCategoriaId',
                value: value
            }).appendTo(`#${formId}`);
        });
    }

    sessionStorage.setItem('selectedCategory', selectedCategory ?? '');
    sessionStorage.setItem('selectedSubCategories', JSON.stringify(selectedSubCategories));
}

/**
 * Gestisce la logica di ricerca quando l'utente clicca sul tasto "Cerca".
 */
async function handleSearch(inputId: string, formId: string): Promise<void> {
    $('#loading2').show();

    try {
        const inputValue = ($(`#${inputId}`).val() as string).trim();
        const form = document.getElementById(formId) as HTMLFormElement | null;

        if (!form) {
            console.error(`Form con id ${formId} non trovato.`);
            $('#loading2').hide();
            return;
        }

        if (!inputValue) {
            const fields = {
                indirizzo: form.querySelector<HTMLInputElement>('[name="Indirizzo"]'),
                provincia: form.querySelector<HTMLInputElement>('[name="Provincia"]'),
                comune: form.querySelector<HTMLInputElement>('[name="Comune"]'),
                regione: form.querySelector<HTMLInputElement>('[name="Regione"]'),
                latitudineNW: form.querySelector<HTMLInputElement>('[name="LatitudineNW"]'),
                latitudineSE: form.querySelector<HTMLInputElement>('[name="LatitudineSE"]'),
                longitudineNW: form.querySelector<HTMLInputElement>('[name="LongitudineNW"]'),
                longitudineSE: form.querySelector<HTMLInputElement>('[name="LongitudineSE"]')
            };

            Object.values(fields).forEach(field => {
                if (field) field.value = '';
            });

            sessionStorage.removeItem('formattedAddress');
            sessionStorage.removeItem('selectedCategory');
            sessionStorage.removeItem('selectedSubCategories');
        }

        const isNumeric = /^\d+$/.test(inputValue);
        // Ricava il tipo dal formId (es. frmcercahome-personale → personale)
        const type = formId.split('-').pop() ?? '';
        if (isNumeric && !getUserHasSelectedPlace(type)) {
            await loadSchedaDettagliataByCodice(inputValue);
            return;
        }

        setCategoryFiltersAndSaveToSession(formId);
        $(`#${formId}`).submit();
    } catch (error) {
        console.error('Errore durante la ricerca:', error);
        $('#loading2').hide();
    }
}

/**
 * Aggiunge event listener per i bottoni di ricerca desktop e mobile.
 */
export function addSearchButtonListener(type: string): void {
    $(`#btn-location-immobili-${type}`).on('click', function () {
        handleSearch(`autocomplete-${type}`, `frmcercahome-${type}`);
    });

    $(`#btn-location-mobili-${type}`).on('click', function () {
        handleSearch(`mobile-code-${type}`, `frmcercahomeMOB-${type}`);
    });

    $(`#mobile-code-${type}`).off('keypress');
    $(`#autocomplete-${type}`).off('keypress');

    $(`#mobile-code-${type}`).on('keypress', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            const inputValue = ($(this).val() as string).trim();
            if (inputValue) {
                handleSearch(`mobile-code-${type}`, `frmcercahomeMOB-${type}`);
            }
        }
    });

    $(`#autocomplete-${type}`).on('keypress', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (getUserHasSelectedPlace(type)) {
                handleSearch(`autocomplete-${type}`, `frmcercahome-${type}`);
            }
        }
    });
}
